import { Check, Users } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { useBooking } from "@/context/BookingContext";
import { VEHICLES } from "@/data";

export const VehicleSelector = () => {
  const { t } = useLang();
  const { vehicle, setVehicle } = useBooking();
  const f = t.fleet;

  const select = (v) => {
    setVehicle(v.name);
    toast.success(`${f.selected}: ${v.name}`);
  };

  return (
    <section id="fleet" className="py-20 md:py-32 bg-sand" data-testid="fleet-section">
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-7xl">
        <div className="max-w-2xl mb-14">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-4">{f.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-jungle mb-5">{f.title}</h2>
          <p className="font-body text-jungle-light/80 leading-relaxed">{f.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {VEHICLES.map((v) => {
            const active = vehicle === v.name;
            return (
              <button
                key={v.id}
                onClick={() => select(v)}
                data-testid={`vehicle-card-${v.id}`}
                className={`group relative text-left bg-white border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                  active ? "border-teal ring-2 ring-teal" : "border-border"
                }`}
              >
                {active && (
                  <span className="absolute top-3 right-3 z-10 bg-teal text-sand w-6 h-6 flex items-center justify-center rounded-full" data-testid={`vehicle-check-${v.id}`}>
                    <Check size={14} />
                  </span>
                )}
                <div className="aspect-[4/3] flex items-center justify-center p-3 bg-white overflow-hidden">
                  <img src={v.image} alt={v.name} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
                <div className="px-4 pb-4 pt-1">
                  <h3 className="font-heading text-xl font-semibold text-jungle">{v.name}</h3>
                  <span className="font-body text-xs text-jungle-light/60 flex items-center gap-1 mt-1">
                    <Users size={12} className="text-teal" /> {v.capacity} {f.seats}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
